/**
 * Page Labels Configuration
 * 페이지별 라벨 설정
 */

export type PageLabelMap = Record<string, string>;

/**
 * 기본 페이지 라벨 맵
 * userType에 따라 동적으로 변경되는 라벨은 getPageLabel 함수에서 처리
 */
export const PAGE_LABELS: PageLabelMap = {
    dashboard: '대시보드',
    delivery_history: '배달 내역 조회',
    delivery_history_detail: '배달 내역 상세',
    rider_status: '라이더 현황',
    rider_detail: '라이더 상세',
    rider_work_status: '라이더 근무 현황',
    partner_status: '협력사 현황',
    partner_fee_to_head: '협력사 → 본사 수수료',
    rider_fee_to_supplier: '라이더 → 협력사 수수료',
    partner_settlement: '협력사 주정산내역',
    settlement_history: '정산내역',
    transaction_history: '입출금내역',
    virtual_account: '가상계좌 관리',
    deduction: '일차감',
    deduction_partner_to_head: '협력사 → 본사 일차감',
    deduction_rider_to_head: '라이더 → 본사 일차감',
    deduction_rider_to_supplier: '라이더 → 협력사 일차감',
    promotion: '프로모션',
    promotion_head_to_supplier: '본사 → 협력사 프로모션',
    promotion_head_to_rider: '본사 → 라이더 프로모션',
    promotion_supplier_to_rider: '협력사 → 라이더 프로모션',
    fee_management: '본사 수수료 관리',
    withdrawal_restriction: '출금 제한',
    transfer_management: '송금 관리',
    rider_history_week: '라이더 주정산내역',
    rider_history_pre: '라이더 선정산내역',
    user_management: '사용자 관리',
    withdraw_request: '탈퇴 요청 관리',
    authority_management: '권한 설정',
    system_settings: '시스템 설정',
    backup_restore: '백업/복구',
    common_code: '공통코드 관리',
    common_code_add: '공통코드 추가',
    balance_snapshot: '잔액 스냅샷',
    re_settlement: '재마감',
    notice_management: '공지 관리',
    maintenance_management: '점검 관리',
    settlement_upload: '정산서 업로드',
    slot_management: '슬롯 관리',
    holiday_management: '공휴일 관리',
    standard_area_management: '표준권역 관리',
};

/**
 * 페이지 라벨 조회 함수
 * @param page 페이지 ID
 * @param userType 사용자 타입 (HEADQUARTERS | SUPPLIER)
 * @param isEditMode 공통코드 편집 모드 여부
 */
export const getPageLabelByType = (page: string, userType?: string, isEditMode?: boolean): string => {
    // 공통코드 추가/수정 동적 라벨
    if (page === 'common_code_add') {
        return isEditMode ? '공통코드 수정' : '공통코드 추가';
    }

    return PAGE_LABELS[page] || page;
};
